export default {
    parseMigrationSettingsResponse(state, response) {
        state.jiraEmail = response.jiraEmail ?? '';
        state.jiraToken = '';
        state.hasJiraToken = response.hasJiraToken ?? false;
        state.migrationToken = '';
        state.hasMigrationToken = response.hasMigrationToken ?? false;
        state.enableMigratedProfiles = response.enableMigratedProfiles ?? false;
    },
    setJiraEmail(state, email) {
        state.jiraEmail = email;
    },
    setJiraToken(state, token) {
        state.jiraToken = token;
    },
    setMigrationToken(state, token) {
        state.migrationToken = token;
    },
    setEnableMigratedProfiles(state, enabled) {
        state.enableMigratedProfiles = enabled;
    },
    showLoader(state, loaderVisible) {
        state.loaderVisible = loaderVisible;
    },
};



// WEBPACK FOOTER //
// ./src/store/modules/migration/mutations.js